import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.CYAN,
    codeProp: 'doNo',
    detailUrl: '/DoDetail',
    detailIdProp: 'doId',
    listUrl: '/DoList',
    mapProp: 'doMap',
    name: '维度对象',
    textProp: 'doName',
    type: 'DO',
}
